{
  "YEAR_IN_REVIEW": {
    "TITLE": "Year in Review",
    "LOADING": "Loading your year in review...",
    "ERROR": "Failed to load year in review",
    "CLOSE": "Close",
    "CONVERSATIONS": {
      "TITLE": "You have handled",
      "SUBTITLE": "conversations",
      "FALLBACK": "This year wasn't about the numbers. It was about showing up.",
      "COMPARISON": {
        "0_50": "You showed up, and that's how every good inbox begins.",
        "50_100": "You kept the replies flowing and the conversations alive.",
        "100_500": "You handled serious volume and kept everything on track.",
        "500_2000": "You kept things moving while the volume kept climbing.",
        "2000_10000": "You ran high traffic through your inbox without breaking a sweat.",
        "10000_PLUS": "That's a full city of customers knocking on your door. You made it look effortless."
      }
    },
    "BUSIEST_DAY": {
      "TITLE": "Your busiest day was",
      "MESSAGE": "{count} conversations that day.",
      "COMPARISON": {
        "0_5": "A warm-up lap that barely woke the inbox.",
        "5_10": "Enough action to justify a second cup of coffee.",
        "10_25": "Things got busy and the inbox stayed on its toes.",
        "25_50": "A proper rush that barely broke a sweat.",
        "50_100": "Controlled chaos, handled like a normal Tuesday.",
        "100_500": "Absolute dumpster fire, somehow still shipping replies.",
        "500_PLUS": "The inbox lost all chill and never slowed down."
      }
    },
    "PERSONALITY": {
      "TITLE": "Your support personality is",
      "MESSAGES": {
        "SWIFT_HELPER": "You replied in {time} on average. Faster than most notifications.",
        "QUICK_RESPONDER": "You replied in {time} on average. The inbox barely waited.",
        "STEADY_SUPPORT": "You replied in {time} on average. Calm pace, solid replies.",
        "THOUGHTFUL_ADVISOR": "You replied in {time} on average. Took the time to get it right."
      }
    },
    "THANK_YOU": {
      "TITLE": "Congratulations on surviving the inbox of {year}.",
      "MESSAGE": "Thank you for your incredible dedication to supporting customers throughout this year. Your hard work has made a real difference, and we're grateful to have you on this journey. Here's to making {nextYear} even better together!"
    },
    "SHARE_MODAL": {
      "TITLE": "Share Your Year in Review",
      "PREPARING": "Preparing your image...",
      "DOWNLOAD": "Download",
      "SHARE_TITLE": "My {year} Year in Review",
      "SHARE_TEXT": "Check out my {year} Year in Review with Chatwoot!",
      "BRANDING": "Made with Chatwoot"
    },
    "BANNER": {
      "TITLE": "Your {year} Year in Review is here",
      "BUTTON": "See your impact"
    },
    "NAVIGATION": {
      "PREVIOUS": "Previous",
      "NEXT": "Next",
      "SHARE": "Share"
    }
  }
}
